module.exports = __webpack_public_path__ + "img/tenant-logo.1789f9ea.png";